import { render, staticRenderFns } from "./SafetyInspectionDetail.vue?vue&type=template&id=1baa9594&scoped=true&"
import script from "./SafetyInspectionDetail.vue?vue&type=script&lang=js&"
export * from "./SafetyInspectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SafetyInspectionDetail.vue?vue&type=style&index=0&id=1baa9594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa9594",
  null
  
)

export default component.exports